import { useMutation } from '@tanstack/react-query';
import { sendMessage } from '../api/chat';
import { IMessage } from '../interface/message';

export const useChatStream = () => {
  const mutation = useMutation({
    mutationFn: async ({ message, onChunk }: { message: IMessage, onChunk: (chunk: string) => void }) => {
      return await sendMessage(message, onChunk);
    }
  });

  const sendMessageStream = async (message: IMessage, onChunk: (chunk: string) => void) => {
    mutation.mutate({ message, onChunk });
  };

  return {
    sendMessage: sendMessageStream,
    isLoading: mutation.isPending,
    error: mutation.error?.message || null,
  };
}; 
